var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgEmptyArticle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 112,
    viewBox: "0 0 110 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\x82\xB4\xEA\xB0\x80\xEC\x9E\x91\xEC\x84\xB1\xED\x95\x9C\xEA\xB8\x80\xEA\xB7\xB8\xEB\x9E\x98\xED\x94\xBD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2608924"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 157",
    cx: 55.094,
    cy: 54.4788,
    r: 54.4788,
    fill: "#66A3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 197",
    x: 18.3701,
    y: 25.5039,
    width: 73.4498,
    height: 86.4117,
    rx: 7,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6993 25.5029L73.6993 37.0444C73.6993 40.9104 76.8333 44.0444 80.6993 44.0444L91.8193 44.0444L73.6993 25.5029Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.8202 44.0454V32.5039C91.8202 28.6379 88.6862 25.5039 84.8203 25.5039H73.7002L91.8202 44.0454Z",
    fill: "#66A3FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 2608926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.82 56.0736V98.9645C90.4051 99.9154 88.8032 100.587 87.0856 100.878C82.3318 101.686 77.9526 100.878 74.1784 97.798C71.6526 95.7386 69.4342 93.3616 68.4066 90.1377C68.1473 89.3294 67.8016 88.7712 66.8797 88.9733C65.8137 89.2139 65.8329 90.1666 66.1018 90.8403C66.7164 92.3511 67.4175 93.862 68.3106 95.2189C68.9156 96.1428 68.7812 96.4604 67.8592 96.8742C66.874 97.3194 65.9049 97.8209 64.9365 98.3221C63.0164 99.3157 61.0988 100.308 59.0623 100.858C52.0229 102.754 44.5033 99.2608 42.1985 91.7352C40.8924 87.472 41.6126 83.2955 44.3977 79.7155C45.819 77.8967 47.5573 76.3377 49.8333 75.5486C50.0818 75.4634 50.2947 75.2711 50.5387 75.0507C50.653 74.9474 50.7741 74.838 50.9089 74.7306L50.9377 74.7402C49.4588 72.7193 48.8922 70.4097 48.8345 68.0904C48.7481 64.8858 49.7661 61.9218 51.9173 59.4485C54.6063 56.3498 57.9195 54.6561 62.0971 54.4925C66.8797 54.3 70.7691 56.1092 74.0343 59.4004C75.5133 60.8824 76.8194 62.5762 78.0102 64.2988C78.6632 65.2419 79.0762 66.4159 79.3451 67.5515C79.566 68.4753 79.8061 69.1586 80.8625 68.9758C81.8228 68.8122 82.2358 68.023 81.8036 66.9548C81.256 65.5905 80.6172 64.2547 79.9795 62.9211C79.7895 62.5238 79.5997 62.1268 79.4123 61.7293C79.3129 61.5167 79.186 61.3132 79.041 61.081C78.9761 60.9768 78.9075 60.8669 78.8361 60.7477C79.6308 60.3619 80.4146 59.9612 81.1958 59.5619C82.8503 58.7162 84.4929 57.8765 86.2021 57.1966C88.0936 56.4434 89.9659 56.0715 91.82 56.0736Z",
    fill: "#ADC7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M72.6945 80.1419C73.7128 80.1419 74.5384 78.8666 74.5384 77.2934C74.5384 75.7202 73.7128 74.4448 72.6945 74.4448C71.6761 74.4448 70.8506 75.7202 70.8506 77.2934C70.8506 78.8666 71.6761 80.1419 72.6945 80.1419Z",
    fill: "#464444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M82.8517 79.9681C83.87 79.9681 84.6956 78.6927 84.6956 77.1195C84.6956 75.5463 83.87 74.271 82.8517 74.271C81.8333 74.271 81.0078 75.5463 81.0078 77.1195C81.0078 78.6927 81.8333 79.9681 82.8517 79.9681Z",
    fill: "#464444"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEmptyArticle);
export default __webpack_public_path__ + "static/media/img_empty_article.205f968c5adc093a526450f102c4d032.svg";
export { ForwardRef as ReactComponent };